import {Component, Input, OnInit} from '@angular/core';
import {IconService} from '../../../shared/services/icon/icon.service';
import {ProjectLastMeasureComponent} from '../project-last-measure/project-last-measure.component';
import {MatDialog} from '@angular/material/dialog';
import {GraphicalViewListComponent} from '../../../shared/components/graphical-view-list/graphical-view-list.component';
import {ModalService} from '../../../shared/services/modal/modal.service';
import {ProjectService} from '../../../shared/services/project/project.service';
import {ProjectExportCsvComponent} from '../project-export-csv/project-export-csv.component';
import {ActivatedRoute} from '@angular/router';
import {AuthenticationService} from '../../../shared/services/authentication/authentication.service';

@Component({
  selector: 'app-project-sub-menu',
  templateUrl: './project-sub-menu.component.html',
  styleUrls: ['./project-sub-menu.component.scss']
})
export class ProjectSubMenuComponent implements OnInit {
  showSpinner: boolean = false;
  public project: any;
  public wimdSub: any;
  public projectId: any;

  constructor(public iconService: IconService,
              public authenticationService: AuthenticationService,
              private matDialog: MatDialog,
              private modalService: ModalService,
              private projectService: ProjectService,
              private route: ActivatedRoute) {
  }

  @Input() topLocation: boolean = true;
  @Input() forGraphicComponent: boolean = false;

  ngOnInit(): void {
    this.projectId = (<any>this.route.params).value.idProject;
    if (this.projectId) {
      this.showSpinner = true;
      this.projectService.getProject(this.projectId)
        .subscribe(
          (project: any) => {
            this.project = project;
            this.wimdSub = !isNaN(parseInt(project.project_wimd_subscription));
            this.showSpinner = false;
          }
        );
    }
  }

  getClass() {
    return this.topLocation ? 'btn top-list-tools' : 'btn list-tools';
  }

  openLastMeasureModal(idProject) {
    const data = {
      idProject
    };
    this.matDialog.open(ProjectLastMeasureComponent, {
      height: '90%',
      width: '95%',
      data
    });
  }

  openExportCsvModal(idProject, start_date, end_date) {
    const data = {
      start_date,
      end_date,
      idProject
    };
    this.matDialog.open(ProjectExportCsvComponent, {
      height: '90%',
      width: '95%',
      data
    });
  }

  openGraphicalViewListModal() {
    const modalRef = this.modalService.openNgbModal(GraphicalViewListComponent, {size: 'lg'});
    modalRef.componentInstance.projectId = this.projectId;
  }

  propertyExists(property) {
    return property !== undefined;
  }

  openLink(url = null) {
    if (url) {
      window.open(url, '_blank');
    }
  }
}
